<template>
  <v-dialog v-model="copyableDialog" persistent max-width="500">
    <v-card class="pa-4">
      <v-card-text class="pt-3 pb-3 box" v-show="button !== ''">
        <v-flex class="copy mb-3">
          <v-layout class="justify-end">
            <v-layout
              v-if="button === 'hardware'"
              class="justify-start subheading pt-3 pl-3 font-weight-bold"
              style="color: #4caf50"
            >Success! See details below.</v-layout>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" large icon @click.stop.prevent="copyText" v-on="on">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copy details</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <div v-if="button === 'hardware'" ref="hardware" class="subheading">
          <div cols="12" class="py-2">
            {{ selectedOrder.orderType === "normal" ? "Standard" : "QBR" }}
            {{ selectedOrder.ubDealerID }} {{ selectedOrder.dealerFullName }}
          </div>
          <div cols="12" class="py-2">Ticket Number {{ selectedOrder.kayakoConversation }}</div>
          <div
            cols="12"
            class="py-2"
          >Hardware ordered via MIA</div>
          <div cols="12" class="py-2">Order Number {{ selectedOrder.orderID }}</div>
          <div cols="12" class="py-2">
            <div
              v-for="(item, index) in copyableData"
              :key="index"
            >{{ item.itemName }} x {{ item.fulfilledQuantity }}</div>
          </div>
          <div cols="12">Total: {{ getTotal() }}</div>
        </div>
        <div v-else ref="mac">
          <div>
            <p
              v-for="(item, index) in copyableData"
              :key="index"
            >{{ item.product }} {{ item.macAddress }} / {{ item.serialNumberSTR }}</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-0 mt-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" medium @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  name: "CopyableText",
  props: {
    copyableDialog: { type: Boolean, required: true },
    copyableData: { type: Array },
    component: { type: String },
  },
  data () {
    return {
      total: 0,
      button: "",
    };
  },
  created () {
    let vm = this;
    vm.button = this.component;
  },
  methods: {
    ...mapOrderActions(["listOrders"]),
    copyText () {
      let vm = this;
      vm.selectText(
        vm.button === "hardware" ? vm.$refs.hardware : vm.$refs.mac
      );
      document.execCommand("copy");
    },
    selectText (element) {
      var range;
      if (document.selection) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    close () {
      let vm = this;
      window.getSelection().removeAllRanges();
      vm.$emit("close");
    },
    getTotal () {
      let vm = this;
      let total = 0;

      if (vm.hardwareDialog) {
        vm.listOrders(vm.selectedOrder.orderID).then(data => {
          if (data && data[0].orderView) {
            let hardwareOrder = data[0].orderView.hardwareOrder;
            total = hardwareOrder.subTotal + hardwareOrder.freight + hardwareOrder.totalGst;
          }
        });
      }

      return total.toFixed(2);
    }
  },
  computed: {
    ...mapGetters("orders", ["selectedOrder"])
  }
};
</script>

<style scoped>
.box {
  border: 1px solid #9c9c9c;
  border-radius: 0 !important;
}

.copy {
  background-color: #f3f3f3;
}
</style>
